import { postAPICall } from './apiCall'

export const saveNewJourney = data => {
  return postAPICall('hierarchical-insert', { body: [data] })
}
